export interface IDropdownSettings {
  allowSearchFilter?: boolean;
  clearSearchFilter?: boolean;
  closeDropDownOnSelection?: boolean;
  defaultOpen?: boolean;
  enableCheckAll?: boolean;
  idField?: string;
  itemsShowLimit?: number;
  limitSelection?: number;
  maxHeight?: number;
  noDataAvailablePlaceholderText?: string;
  searchPlaceholderText?: string;
  selectAllText?: string;
  showSelectedItemsAtTop?: boolean;
  singleSelection?: boolean;
  textField?: string;
  unSelectAllText?: string;
}

export class ListItem {
  id: String;
  text: String;

  public constructor(source: any) {
    if (typeof source === "string") {
      this.id = this.text = source;
    }
    if (typeof source === "object") {
      this.id = source.id;
      this.text = source.text;
    }
  }
}
